export default __webpack_public_path__ + "static/media/others.1dc2bb84.svg";